import Vue from 'vue'
import Scripts from '@/plugins/scripts'

import * as Sentry from '@sentry/browser'
import * as SentryIntegrations from '@sentry/integrations'

// App SASS
import '@/assets/scss/embed.scss'

// App component
import App from '@/embed/App.vue'

// import script as Google Analytics/TypeKit and HotJar
Vue.use(Scripts, {
  GAId: process.env.VUE_APP_GA_CODE,
  TypekitId: process.env.VUE_APP_TYPEKIT_CODE
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  created: () => {
    if (process.env.VUE_APP_DEPLOY_ENV !== 'dev') {
      let debug = process.env.VUE_APP_DEPLOY_ENV !== 'production'
      Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_URL,
        release: `al-front@${process.env.VUE_APP_VERSION}`,
        debug: debug,
        integrations: [
          new SentryIntegrations.ExtraErrorData(),
          new SentryIntegrations.Vue({
            Vue,
            attachProps: true
          })
        ]
      })

      Sentry.configureScope(scope => {
        scope.setTag('environment', process.env.VUE_APP_DEPLOY_ENV)
      })
    }
  }
})
